import { Interface, getAddress, getBigInt, parseUnits } from 'ethers';

export const ERC20_ABI = [
  'function transfer(address to, uint256 amount) returns (bool)',
  'function balanceOf(address account) view returns (uint256)',
  'function decimals() view returns (uint8)',
];

const IFACE = new Interface(ERC20_ABI);

export function encodeTransfer(recipient: string, amount: bigint): string {
  return IFACE.encodeFunctionData('transfer', [getAddress(recipient), amount]);
}

export function encodeBalanceOf(owner: string): string {
  return IFACE.encodeFunctionData('balanceOf', [getAddress(owner)]);
}

export function decodeBalance(data: string): bigint {
  const decoded = IFACE.decodeFunctionResult('balanceOf', data);
  return getBigInt(decoded[0]);
}

export function toUnits(humanAmount: string, decimals: number): bigint {
  return parseUnits(humanAmount, decimals);
}
